import {BaseFormModel} from './base-form-model';
import {MenuLabel} from './menu-label';
import {MenuToppingModifierSelection} from './menu-topping-modifier-selection';
import {MenuToppingModifierGroup} from './menu-topping-modifier-group';
import {MenuToppingModifier} from './menu-topping-modifier';

export class MenuTopping extends BaseFormModel<MenuTopping> {
    id: number;
    name: string;
    description: string;
    available: boolean;
    labels: MenuLabel[];
    modifiers: MenuToppingModifier[];
    modifierSelections: MenuToppingModifierSelection[];
    modifierGroups: MenuToppingModifierGroup[];
}
